import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { CheckboxModule } from "primeng/checkbox";

/*
  Example usage: 
  {
    key: "isApprovalRequired",
    type: "checkbox",
    defaultValue: true,
    props: {
      label: {
        "en": "Approval required",
        "fi": "Hyväksyntä vaadittu",
        "sv": "Godkännande nödvändigt"
      },
      "description": {
        "en": "Check this if approval is required for this process",
        "fi": "Täytä tämä, jos hyväksyntä on vaadittu tälle prosessille",
        "sv": "Markera detta om godkännande krävs för den här processen"
      } // Optional
    },
  },


  ////////////

  JSON example:
  {
    "key": "isApprovalRequired",
    "type": "checkbox",
    "defaultValue": true,
    "props": {
      "label": {
        "en": "Approval required",
        "fi": "Hyväksyntä vaadittu",
        "sv": "Godkännande nödvändigt"
      },
      "description": {
        "en": "Check this if approval is required for this process",
        "fi": "Täytä tämä, jos hyväksyntä on vaadittu tälle prosessille",
        "sv": "Markera detta om godkännande krävs för den här processen"
      } // Optional
    }
  },
*/

@Component({
  selector: "app-checkbox",
  templateUrl: "./checkbox.type.html",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CheckboxModule],
})
export class CheckboxComponent extends FieldType<FieldTypeConfig> implements OnInit {
  ngOnInit() {
    // If nothing has ever been set, default to false
    if (this.formControl.value == null) {
      this.formControl.patchValue(false, { emitEvent: false });
    }
  }
}
